export default {
    default_per_page : 15,
    default_feed_per_page : 5,
}